/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2020, Zumper
 */

import { EVENT_NAMES, PAGE_NAMES, PROP_NAMES, track } from '@zcode/mixpanel'
import type { Dispatch, GetState } from '../../types'
import { getCommonProps } from '../helpers/getCommonProps'

export const mixpanelTrackZoom =
  ({
    cityState,
    isMobile,
    zoom,
  }: {
    cityState: string | undefined
    isMobile: boolean
    zoom: number
  }) =>
  (_: Dispatch, getState: GetState) => {
    const state = getState()

    const payload = getCommonProps({ state })
    payload[PROP_NAMES.ZOOM_LEVEL] = zoom
    payload[PROP_NAMES.CITY_STATE_LOCATION] = cityState
    payload[PROP_NAMES.PAGE_NAME] = isMobile ? PAGE_NAMES.SEARCH_MAP : PAGE_NAMES.SEARCH

    track({
      event: EVENT_NAMES.ZOOM_MAP,
      payload,
    })
  }
